export default __webpack_public_path__ + "static/media/drawing-woman9-focusfill.6cffbe9d.svg";